import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  registerSupplier,
  getSupplierById,
  updateSupplierById,
} from "../modules/actions";
import EditSupplier from "./View";
import { getBrands } from "../../Brendovi/modules/actions";

const mapStateToProps = (state) => ({
  currentSupplier: state.suppliersReducer.supplierToEdit?.supplier,
  brands: state.brandReducer.brands,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getSupplierById,
      updateSupplierById,
      getBrands,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSupplier);
